import { FC } from 'react';
import { Container } from 'react-bootstrap';
import { Button } from '../../atoms';
import { useNavigate, useParams } from 'react-router-dom';
import cn from 'classnames';
import styles from './LandscapeProjectsAddProjectsContactInformationTemplate.module.css';
import BaseTemplate from '../BaseTemplate';
import LandscapeEditProjectsAddProjectTemplate from '../../../templates/LandscapeEditProjectsAddProjectTemplate';
import { LandscapeProjectsAddProjectsContactInformationOrganism } from '../../organisms';
import { LandscapeContactPersonResponseDto } from '../../../store/landscapeAPI/landscape/dto/response/landscape-contact-person-response.dto';

interface LandscapeProjectsAddProjectsContactInformationTemplateProps {
  data: LandscapeContactPersonResponseDto[];
  handleDelete: (id: string) => void;
}

const LandscapeProjectsAddProjectsContactInformationTemplate: FC<
  LandscapeProjectsAddProjectsContactInformationTemplateProps
> = ({ data, handleDelete }) => {
  const navigate = useNavigate();
  const { id, projectId } = useParams();
  return (
    <>
      <BaseTemplate>
        <Container>
          <LandscapeEditProjectsAddProjectTemplate>
            <div className={cn(styles.landscapeAboutContactPersonsWrapper)}>
              <div className={cn(styles.button)}>
                <Button
                  variant="dark"
                  onClick={() =>
                    navigate(
                      `/landscapes/edit/${id}/projects/add-project/${projectId}/contact-information/add-contact-person`
                    )
                  }
                >
                  Add Contact Person
                </Button>
              </div>
              <div className={cn(styles.tableWrapper)}>
                <LandscapeProjectsAddProjectsContactInformationOrganism
                  data={data}
                  handleDelete={handleDelete}
                />
              </div>
            </div>
          </LandscapeEditProjectsAddProjectTemplate>
        </Container>
      </BaseTemplate>
    </>
  );
};

export default LandscapeProjectsAddProjectsContactInformationTemplate;
